export default "__VITE_ASSET__CtZnNnKQ__"